import React, { FC } from 'react';
// USING native View as out default VIEW has issues changing background color easily swap when fixed
import { Switch, View } from 'react-native';
import { iosSwitchBackgroundColor } from '../../../constants/palette';
import GalanoGrotesqueText from '../../styled/GalanoGrotesqueText';

export type SwitchBaseProps = {
  containerStyle: any;
  isEnabled: boolean;
  iosColor?: string;
  text?: string;
  textStyle?: any;
  trackColor: TrackColor;
  thumbColorEnabled: string;
  thumbColorDisabled: string;
  toggleSwitch: (value: boolean) => void;
};

type TrackColor = {
  false: string;
  true: string;
};

const SwitchBase: FC<SwitchBaseProps> = (props) => {
  const {
    containerStyle,
    isEnabled,
    iosColor,
    trackColor,
    text,
    textStyle,
    thumbColorDisabled,
    thumbColorEnabled,
    toggleSwitch,
  } = props;

  const iosBackgroundColor = iosColor || iosSwitchBackgroundColor;
  const selectedThumbColor = isEnabled ? thumbColorEnabled : thumbColorDisabled;

  return (
    <View style={containerStyle}>
      <Switch
        //@ts-ignore
        activeThumbColor={thumbColorEnabled}
        activeTrackColor={thumbColorEnabled}
        trackColor={trackColor}
        thumbColor={selectedThumbColor}
        ios_backgroundColor={iosBackgroundColor}
        onValueChange={toggleSwitch}
        value={isEnabled}
        style={{ transform: [{ scaleX: 1.3 }, { scaleY: 1.3 }] }}
      />
      {!!text && (
        <GalanoGrotesqueText style={textStyle}>{text}</GalanoGrotesqueText>
      )}
    </View>
  );
};

export default SwitchBase;
